<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/bank-account">Contas bancárias</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Nova conta</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="save">
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Descrição*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Banco X SA"
                                        v-model="bank.name">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Banco</label>
                                    <multiselect v-model="bank_multiselect" :options="banks_options"
                                        :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectBank">

                                        <template #noResult>
                                            Nenhum banco encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                 <div class="col-xl-2 col-md-2 col-sm-12">
                                    <label for="">Agência</label>
                                    <input type="text" class="form-control" placeholder="Ex: 0001"
                                        v-model="bank.agency">
                                </div>
                                 <div class="col-xl-3 col-md-2 col-sm-12">
                                    <label for="">Conta</label>
                                    <input type="text" class="form-control" placeholder="Ex: 1234-5"
                                        v-model="bank.account">
                                </div>
                                 <div class="col-xl-3 col-md-2 col-sm-12">
                                    <label for="">Tipo da conta</label>
                                   <multiselect v-model="bank.type_account" :options="type_accounts"
                                         placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'">
                                        <template #noResult>
                                            Nenhum tipo encontrado.
                                        </template>
                                    </multiselect>
                                        
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>
                                    <router-link to="/bank-account" class="btn btn-danger ml-3"><i
                                            class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { loadBank } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'

export default {

    components: { Loading,Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            bank_multiselect: '',
            banks_options: [],
            type_accounts:['Conta Corrente','Conta Poupança'],
            bank: {
                name: '',
                bank: '',
                agency:'',
                account:'',
                type_account:''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.bank.name != '';
        }
    },
    mounted() {
        this.isLoading = false;
         const response_banks = this.getBank();
        response_banks.then(() => {
            this.banks_options = this.banks.map(item => ({
                title: item.fullName,
                value: 'Código: ' + item.code + ' / ' + 'Banco: ' + capitalize(item.name)
            }));
        });
    },
    methods: {
        onCancel() { },
         async getBank() {
            this.isLoading = true;
            const response = await loadBank().then((response) => {
                let banks = response;
                banks.sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }
                    return 0;
                });
                this.banks = banks;

                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });

            return response;
        },

         bankWithLang({ value }) {
            return value;
        },
        handleSelectBank(option) {
            this.bank.bank = option.value;
        },

        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/bank-account', this.bank)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Conta bancária cadastrada com sucesso!",
                        type: 'success'
                    });
                    this.bank = {};
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>